export default __webpack_public_path__ + "static/media/icon-sidebar-account.c30d6c5b.svg";